import {connect} from 'react-redux';

import {openInBrowser} from '../../../../../../srcCommon/browser/openInBrowser';
import {makeMapStateToProps} from '../../../../../helpers/reselectHelpers';
import {ConversationModel} from '../../../../../models/api/conversationModel';
import {LoadedMessageModel} from '../../../../../models/api/messageModel';
import {
  openEmlPrintPopup,
  openMessagePrintPopup,
  openMessageSourcePopup,
} from '../../../../../services/popups';
import {AppState} from '../../../../../store/appState';
import {getLegacyMessageMoreDropdownEntryPoints} from '../../../../../store/data/applications/legacyApplicationsSelectors';
import {getCompanyHost} from '../../../../../store/data/company/companySelectors';
import {toggleMarkConversationAsSeenAction} from '../../../../../store/data/conversations/seenConversationsActions';
import {
  getHasListSendingMessagesInSentFolder,
  getHasNewVisitorUrlExperience,
} from '../../../../../store/featureFlags/featureFlagsSelectors';
import {CellsContext} from '../../../../../store/panels/cells/context/cellsContext';
import {EmlSource} from '../../../../../store/panels/eml/emlPanelState';
import {
  makeGetCanSplitMessage,
  makeGetShowReplyAction,
} from '../../../../../store/panels/viewer/message/messageViewerSelectors';
import {MessageViewerMoreDropdown} from './messageViewerMoreDropdown';

/*
 * Props.
 */

interface MessageViewerMoreDropdownContainerProps {
  conversation: ConversationModel | undefined;
  message: LoadedMessageModel;
  isFirstMessage?: boolean;
  cellsContext: CellsContext;
  selectedInboxId: number | undefined;
  emlSource?: EmlSource;
}

/*
 * Selectors.
 */

function getConversation(_state: AppState, props: MessageViewerMoreDropdownContainerProps) {
  return props.conversation;
}

function getMessage(_state: AppState, props: MessageViewerMoreDropdownContainerProps) {
  return props.message;
}

function getSelectedInboxId(_state: AppState, props: MessageViewerMoreDropdownContainerProps) {
  return props.selectedInboxId;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<MessageViewerMoreDropdownContainerProps>()(() => ({
  host: getCompanyHost,
  canSplit: makeGetCanSplitMessage(getConversation, getMessage),
  showReplyAction: makeGetShowReplyAction(getMessage, getSelectedInboxId),
  hasListSendingMessagesInSentFolder: getHasListSendingMessagesInSentFolder,
  entryPoints: getLegacyMessageMoreDropdownEntryPoints,
  hasNewVisitorUrlExperience: getHasNewVisitorUrlExperience,
}));

export const MessageViewerMoreDropdownContainer = connect(
  mapStateToProps,
  {toggleMarkConversationAsSeenAction},
  (stateProps, dispatchProps, ownProps) => {
    const {conversation, cellsContext, message} = ownProps;

    const onPrintClick = () => {
      if (ownProps.emlSource) {
        openEmlPrintPopup(message, ownProps.emlSource);
      } else {
        openMessagePrintPopup(message);
      }
    };

    const onViewSourceClick = () => {
      openMessageSourcePopup(message);
    };

    const onMarkUnreadClick = () => {
      if (!conversation) {
        return;
      }

      dispatchProps.toggleMarkConversationAsSeenAction([conversation.id], false, {
        cellsContext,
        seenAt: ownProps.isFirstMessage ? 0 : message.sentAt - 1000,
      });
    };

    return {
      ...ownProps,
      ...stateProps,
      onPrintClick,
      onViewSourceClick,
      onMarkUnreadClick,
      openInBrowser,
    };
  },
)(MessageViewerMoreDropdown);
